var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZ(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.734375,
    y: 0.275391,
    width: 82.8808,
    height: 82.8808,
    rx: 8.02073,
    fill: "#E6F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1256 22.0099C47.6961 22.3279 47.9761 22.994 47.8043 23.6242L44.0326 37.4538H57.7967C58.3623 37.4538 58.8739 37.7894 59.0993 38.3081C59.3247 38.8268 59.2209 39.4298 58.835 39.8433L38.9503 61.1483C38.5047 61.6258 37.7908 61.7378 37.2203 61.4198C36.6499 61.1017 36.3698 60.4356 36.5417 59.8055L40.3134 45.9758H26.5493C25.9837 45.9758 25.472 45.6403 25.2466 45.1216C25.0212 44.6029 25.125 43.9999 25.5109 43.5864L45.3956 22.2813C45.8413 21.8039 46.5551 21.6918 47.1256 22.0099Z",
    fill: "#262626"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZ);
export default __webpack_public_path__ + "static/media/z.0f610283612e4b66745a6246338ef01f.svg";
export { ForwardRef as ReactComponent };